import { Design } from '@/types';
import { loadImage } from '@/utils/image/loadImage';
import { getDesignImageUrl } from '@/utils/imageUrls/getDesignImageUrl';
import { ImageParams } from '@/utils/imageUrls/stringifyImageParams';
import { DESIGN_MIN_SIZE } from './constants';

export const initDesignImage = async (design: Design): Promise<HTMLImageElement> => {
  const params: ImageParams = {
    sameOrigin: true,
  };

  const { width, height } = design.size;
  if (width < DESIGN_MIN_SIZE && height < DESIGN_MIN_SIZE) {
    throw new Error('design size too small to compute masked preview image');
  } else if (width >= height) {
    params.width = DESIGN_MIN_SIZE;
  } else {
    params.height = DESIGN_MIN_SIZE;
  }

  return loadImage(getDesignImageUrl(design.id, params), true);
};
